import { handleActions } from 'redux-actions';
import { v4 as guid } from 'uuid';
import Immutable, { asMutable, setIn } from 'seamless-immutable';

import { CREATE_TOAST, REMOVE_TOAST } from './actions';

/*
 * A toast object should have at least a message. There is an optional status
 * which controls the color of the toast. Each toast lives in `state.queue` and
 * is removed when no longer displayed. The keys in the toast object should
 * match the available props on the Toast component.
 *
 * There are two contexts for toasts:
 * - "app" context toasts are automatically handled by the App component,
 *   and use a absolute positioned Toast component at the top of the page,
 *   which disappear after a few moments. If there are multiple toasts,
 *   each will be shown in succession. If no context is passed to createToast(),
 *   it will be marked as an "app" context toast.
 * - "local" context toasts are automatically handled by the Header component,
 *   and use a relative positioned ToastWithIcon component, above the page
 *   heading. These are intended to remain on the page until the user navigates
 *   away. Only the last "local" toast will be shown.
 *
 * @example
 *
 * {
 *   message: 'Invalid phone number ${phone}.',
 *   variables: { phone: '123' },
 *   status: 'error',
 * }
 */
export const INITIAL_STATE = Immutable({
  queue: [],
});

export const actionMap = {
  [CREATE_TOAST]: (state, { payload }) => {
    const queue = asMutable(state.queue);

    if (!payload.status) {
      payload.status = 'ok';
    }

    if (!payload.context) {
      payload.context = 'app';
    }

    payload.variables = payload.variables || {};

    payload.id = guid();

    queue.push(payload);
    return setIn(state, ['queue'], queue);
  },
  [REMOVE_TOAST]: (state, { payload: id }) => {
    const queue = state.queue.filter((toast) => toast.id != id);
    return setIn(state, ['queue'], queue);
  },
};

export default handleActions(actionMap, INITIAL_STATE);
